import styled from 'styled-components';

export const AlignRight = styled.div`
	display: flex;
	justify-content: flex-end;
`;
